import React from 'react';
import { motion } from 'framer-motion';
import { Award, ShieldCheck, Globe, CheckCircle } from 'lucide-react';
const certifications = [{
  name: 'Legally Registered',
  icon: Award,
  description: 'RDC Certified Company'
}, {
  name: 'Conflict-Free',
  icon: Globe,
  description: 'Ethical Sourcing Guarantee'
}, {
  name: 'Quality Assured',
  icon: ShieldCheck,
  description: 'Best Quality Minerals'
}, {
  name: 'Global Operations',
  icon: CheckCircle,
  description: 'Worldwide Trusted Supplier'
}];
export function Certifications() {
  return <section id="certifications" className="py-20 bg-white border-y border-gray-100" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="text-center mb-12" data-id="element-58">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-59">
            Certifications & Quality Assurance
          </h2>
          <p className="text-gray-500" data-id="element-60">
            Certified mining company committed to ethical sourcing and
            international quality standards
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-61">
          {certifications.map((cert, index) => <motion.div key={cert.name} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="flex flex-col items-center text-center p-6 rounded-lg hover:bg-gray-50 transition-colors duration-300" data-id="element-62">
              <div className="p-4 bg-drc-blue/10 rounded-full mb-4 text-drc-blue" data-id="element-63">
                <cert.icon size={32} strokeWidth={1.5} data-id="element-64" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-65">
                {cert.name}
              </h3>
              <p className="text-sm text-gray-500" data-id="element-66">{cert.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}